export default __webpack_public_path__ + "static/media/aadhar-back-preview-icon.9c353865.svg";